import React, { Component } from 'react';
import styled from 'styled-components';

import { store } from '../stores/mainStore';
import { ButtonBar } from '../elements/Elements';
import { integration } from '../integration';
import { CloseButton } from '../elements/Buttons';
import {IFrameWithCloseButton} from './IFrameWithCloseButton';
import { i18n } from '../i18n';
import {Button} from '../elements/Buttons';
//import {Const} from '../stores/Constants';
import { loadB64forCss } from './B64Image';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

const config = window.dodConfig;

var boxesWide = 4;
var boxesTall = 6;

// in the same order as explanation_sheet.jpg
const hands = [
	'three-straight',
	'three-straight-flush',
	'two-pair',
	'three-of-a-kind',
	'four-straight',
	'straight',
	'flush',
	'full-house',
	'three-pair',
	'five-flush-clubs',
	'five-flush-spades',
	'five-flush-hearts',
	'five-flush-diamonds',
	'two-three-of-a-kind',
	'all-red',
	'all-black',
	'four-straight-flush',
	'four-of-a-kind',
	'straight-flush',
	'royal-flush',
	'five-of-a-kind',
	'jackpot',

	//the rest are not currently in game
	'big-house',
	'high-card',
	'pair',
	'six-of-a-kind',
	'four-pair',
];

function getPosition() {
	var goal = 
	// store.activeMatch.matchId === 'intro2' ? 'four-of-a-kind' : 
	// 	(store.activeMatch.handNumber >= store.activeMatch.roundCount && !store.is3HandGame) ? 'jackpot' : 
		store.activeMatch.goals[store.activeMatch.handNumber - 1];
	var pos = hands.indexOf(goal);
	var fromTop = Math.floor(pos / boxesWide);
	var fromLeft = pos % boxesWide;
	return `${fromLeft * (100 / (boxesWide - 1))}% ${fromTop * (100 / (boxesTall - 1))}%`;
}

const HandPage = styled.div`
	/* margin-top: 35%; */
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`;

const Content = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	padding-top: ${(p) => (config.isLandscape ? 50 : 100)}px;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`;

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: ${(p) => (config.isLandscape ? 40 : 90)}vw;
	margin: 0 auto;
	@media (min-aspect-ratio: 9/15) {
		width: 60vw;
	}
`;

const BoxContent = styled.div`
	width: 90vw;
	height: 90vw;
	background-image: url(${p => p.src});
	background-size: ${boxesWide * 100}% ${boxesTall * 100}%;
	background-position: ${getPosition};
	@media (min-aspect-ratio: 9/15) {
		width: 60vw;
		height: 60vw;
	}
`;

@observer
export class ModalHand extends Component {
	@observable loading = true;// window.location.hostname !== "localhost";

	constructor(props) {
		super(props);
		this.previousBackButton = store.onBackButton;
		store.onBackButton = this.close;

		this.imagesToLoad = {
			bkg_LANG: '/assets/languages/*LANG*/explanation_sheet.jpg',
		}
		loadB64forCss(this.imagesToLoad).then(() => this.loading = false);
	}

	continue() {
		window.manager.playAudio('poopPop');
		if(store.activeMatch.matchId === 'intro2')
			integration.postAnalyticsEvent_v2('ftue_close_hand_help', 'ftue');
		else if(store.isFirstTimePractice)
			integration.postAnalyticsEvent_v2('practice_close_hand_help', 'ft_practice');

		store.modal = '';
	}

	learn() {
		window.manager.playAudio('poopPop');
		store.modal = 'learn';
	}
	ranking() {
		window.manager.playAudio('poopPop');
		integration.postAnalyticsEvent(
			'press_help_hand_rank',
			'navigation',
			store.activeMatch.goals[store.activeMatch.handNumber - 1]
		);
		store.modal = 'ranking';
	}

	state = {
		el: null,
		iframe: '',
	};
	close = () => {
		window.manager.playAudio('poopPop');
		this.setState({ iframe: '' });
		store.onBackButton = this.previousBackButton;
	};
	clickFaq() {
		window.manager.playAudio("poopPop");
		if(store.activeMatch.matchId === 'intro2')
			integration.postAnalyticsEvent_v2('ftue_hand_help_faq', 'ftue');
		else if(store.isFirstTimePractice)
			integration.postAnalyticsEvent_v2('practice_hand_help_FAQ', 'ft_practice');
	}
	render() {
		if (this.state.iframe) {
			return <IFrameWithCloseButton 
				onClick={() => {
					store.onBackButton = this.close;
					this.close();
				}}
				iframe={this.state.iframe}
			/>
		}
		return (
			!this.loading && <HandPage>
				<Content>
					<CloseBox>
						<CloseButton top={-3} right={-2} onClick={() => this.continue()}/>
						<BoxContent parent={this.state.el}
							src={this.imagesToLoad['bkg_'+store.getLanguage]}  
						/>
						<ButtonBar>
							{/* <Button w='25vw' color='blue' 
								h={(store.activeMatch.handNumber === store.activeMatch.roundCount ? 9 : 5) +'vw'} 
								fontSize={{en: '4vw', mx:'3.2vw'}}
								onClick={() => {
									this.clickFaq();
									this.setState({ iframe: Const.FAQ_LINK });
								}} 
							>
								{i18n.t('faq')}
							</Button> */}

							{(store.activeMatch.handNumber === store.activeMatch.roundCount && !store.is3HandGame) && (
								<Button h='9vw' w='25vw' color='blue'
									fontSize={{en: '4vw', fr: '3.2vw', it:'3.5vw', mx:'3.2vw'}}
									onClick={this.ranking} 
								>
									{i18n.t('rank-of-hands')}
								</Button>
							)}
						</ButtonBar>
					</CloseBox>
				</Content>
			</HandPage>
		);
	}
}
